import { ErrorResponse, JobCompletedEnum, OperationTypeEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { AllSoakingResponseModel, AssignSoakingDto, assignSoakingForFreezingResponse, JobCompletedStatusDto, ReportSoakingRequest, SoakingDetailsRequest, SoakingDetailViewResponseModel, SoakingDto, SoakingResponseModel, SoakingStatusWiseResponseDto, SoakingStatusWiseResponseModel, VariantNextOpModel, WorkStationsResponseDto, workstationsStatusResponseModel } from '@gtpl/shared-models/production-management';
import { WorkstationService } from '@gtpl/shared-services/production';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { getManager, Raw, Repository } from 'typeorm';
import { WorkStations } from '../workstations/workstations.entity';
import { ProductionInventory } from './entities/production-inventory.entity';
import { ProductionLog } from './entities/production-log.entity';
import { ProductionLogService } from './production-log.service';
import { ProductionInventoryRepository } from './repositories/production-inventory.repository';
import { ProductionLogRepository } from './repositories/production-log.repository';
import { VariantOperationsService } from '../variant-operations/variant-operations.service';
import { OperationSequenceRequest } from './dto/operation-sequence.request';
import appSettings from 'apps/services/config';
import { UnitTypeEnum } from '@gtpl/shared-models/masters';

@Injectable()
export class SoakingService {
    constructor(@InjectRepository(ProductionInventoryRepository)
    private inventoryRepository: ProductionInventoryRepository,
        private variantOperationService: VariantOperationsService,

        @InjectRepository(ProductionLogRepository)
        private logRepository: ProductionLogRepository,
        private logService: ProductionLogService,
        private workstations: WorkstationService,
        private saleOrderService: SaleOrderService) { }
    // constructor(@InjectRepository(ProductionInventoryRepository)
    // private inventoryRepository: ProductionInventoryRepository,
    // private logService:ProductionLogService,
    // private saleOrderService: SaleOrderService) { }


    // async assignSoakingForFreezing(soakingInfo: JobCompletedStatusDto): Promise<assignSoakingForFreezingResponse> {
    //     const updateStatus = await this.repository.update(
    //         { productionLogId: Raw((alias) => `production_log_id = '${soakingInfo.productionLogId}'`) },
    //         { assignFreezing: JobCompletedEnum.YES, assignedTime: Date }
    //     );
    //     if (updateStatus) {
    //         return new assignSoakingForFreezingResponse(true, 1111, 'Updated to Freezing');
    //     } else {
    //         throw new ErrorResponse(9999, 'Failed to update');
    //     }
    // }

    async reportSoakingAssignment(inputReq: ReportSoakingRequest): Promise<assignSoakingForFreezingResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const opSequence = await this.variantOperationService.getOperationSequence(new OperationSequenceRequest(inputReq.plantId, OperationTypeEnum.SOAKING, inputReq.saleOrderItemId));
            let nextOperation = undefined;
            if (opSequence.status) {
                nextOperation = opSequence.data.nextOperation;
            }
            else {
                await manager.releaseTransaction();
                throw new ErrorResponse(99998, 'Next operation not found.');
            }
            console.log(opSequence.data.nextOperation);
            const prodLogUpdateOutPutGrade = await this.logService.updateOutputGradeAndOperationStatus(inputReq.productionLogId, inputReq.workstation, inputReq.lotNumber, inputReq.outputGrade, inputReq.outputQuantity, nextOperation,inputReq.inputQuantity,manager);
            console.log('prodLogUpdateOutPutGrade' + prodLogUpdateOutPutGrade);

            if (prodLogUpdateOutPutGrade) {
                await manager.completeTransaction()
                return new assignSoakingForFreezingResponse(true, 1001, 'Soaking Reported successfully. ');
            }
            else {
                await manager.releaseTransaction()
                return new assignSoakingForFreezingResponse(false, 1001, 'Something went wrong. ');
            }
        } catch (error) {
            await manager.releaseTransaction();
            throw error;
        }
    }
    async createSoakingAssignment(inputReq: AssignSoakingDto): Promise<assignSoakingForFreezingResponse> {
        console.log(inputReq);
        inputReq.ipBoxes = 0
        inputReq.wipQuantity = inputReq.physicalQuantity
        inputReq.operation = OperationTypeEnum.SOAKING


        const manager = new GenericTransactionManager();
        try {
            let columnName = 'plantId';

            const productionInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: inputReq.lotNumber, subLotNumber: inputReq.subLotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: OperationTypeEnum.SOAKING, plantId: inputReq.plantId } });
            console.log(productionInventoryData,'--pro inv data--')
            let prodInvResponse;
            await manager.startTransaction();
            if (productionInventoryData) {
                prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryQuantity(inputReq, columnName);
            } else {
                // Getting variant information for so item id
                const variantInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: inputReq.saleOrderItemId });
                if (!variantInfo.status) {
                    throw new ErrorResponse(10000, 'Variant information not found');
                }
                const nextOperation = await this.variantOperationService.getNextOperationForVariantId(new VariantNextOpModel(OperationTypeEnum.SOAKING, variantInfo.data.variantId, inputReq.plantId));
                const prodInv = new ProductionInventory();
                prodInv.lotNumber = inputReq.lotNumber;
                prodInv.createdUser = inputReq.createdUser;
                prodInv.subLotNumber = inputReq.subLotNumber;
                prodInv.saleOrderId = inputReq.saleOrderId;
                prodInv.saleOrderItemId = inputReq.saleOrderItemId;
                prodInv.operation = OperationTypeEnum.SOAKING;
                prodInv.nextOperation = nextOperation;
                prodInv.wipQuantity = inputReq.physicalQuantity;
                prodInv.inputGrade = String(inputReq.inputGrade);
                prodInv.boxes = inputReq.boxes;
                prodInv.plantId = inputReq.plantId;
                if (inputReq.subPlantId) {
                    prodInv.subPlantId = inputReq.subPlantId;
                }
                prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInv);
            }
            console.log('prodInvResponse' + prodInvResponse.productionInventoryId);
            if (prodInvResponse) {
                const productionLogObj = new ProductionLog();
                productionLogObj.lotNumber = inputReq.lotNumber;
                productionLogObj.subLotNumber = inputReq.subLotNumber;
                productionLogObj.saleOrderId = inputReq.saleOrderId;
                productionLogObj.saleOrderItemId = inputReq.saleOrderItemId;
                productionLogObj.operationType = OperationTypeEnum.SOAKING;
                // job number generation 
                let today = new Date();
                let CurrentYear = today.getFullYear();
                let CurrentMonth = today.getMonth();
                let fromDate = 0;
                let toDate = 0;
                let totalRecords = await (await this.logRepository.find({ where: { operationType: OperationTypeEnum.SOAKING } })).length;
                if (CurrentMonth < 4) {
                    fromDate = (CurrentYear - 1);
                    toDate = (CurrentYear );
                } else {
                    fromDate = (CurrentYear );
                    toDate = (CurrentYear + 1);
                }

                totalRecords = totalRecords + 1;

                var refNo = totalRecords + "";
                while (refNo.length < 4) refNo = "0" + refNo;

                const soakingJobNo = "Soaking/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;

                productionLogObj.jobNumber = soakingJobNo;//need to write auto generate logic
                productionLogObj.plantId = inputReq.plantId;
                if (inputReq.subPlantId) {
                    productionLogObj.subPlantId = inputReq.subPlantId;
                }
                productionLogObj.workStationType = inputReq.workStationType;
                // productionLogObj.workstation = new WorkStations();
                productionLogObj.workStation = inputReq.workstation;
                productionLogObj.jobStatus = JobCompletedEnum.NO;
                productionLogObj.inputGrade = String(inputReq.inputGrade);
                productionLogObj.inputQuantity = inputReq.physicalQuantity;
                productionLogObj.plannedGrade = inputReq.boxes;
                productionLogObj.soakingStyle = inputReq.soakingStyle;
                productionLogObj.soakingTime = inputReq.soakingTime;
                productionLogObj.assignedTime = inputReq.assignedTime;
                productionLogObj.assignedUser = inputReq.createdUser;//need to get assigned user
                productionLogObj.shift = inputReq.shift;
                productionLogObj.createdUser = inputReq.createdUser;
                productionLogObj.prodInvId =  productionInventoryData ? productionInventoryData.productionInventoryId : prodInvResponse.productionInventoryId;
                // console.log(productionLogObj,'--productionLogObj--')
                const saveProdLog = await manager.getCustomRepository(ProductionLogRepository).save(productionLogObj);
                // console.log(saveProdLog,'--saveProdLog--')
                const updatePrevOPQty = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryIssuedQuantity(inputReq.lotNumber, inputReq.subLotNumber, inputReq.saleOrderId, inputReq.saleOrderItemId, inputReq.productionInventoryId, inputReq.plantId, inputReq.physicalQuantity);
                // console.log(updatePrevOPQty,'--updatePrevOPQty--')
                if (saveProdLog && updatePrevOPQty) {
                    manager.completeTransaction();
                    return new assignSoakingForFreezingResponse(true, 5555, 'Work station allocated and material assigned to Soaking', true)
                } else {
                    await manager.releaseTransaction();
                    return new assignSoakingForFreezingResponse(false, 9999, 'some thing went wrong', false)
                }
            }

        } catch (error) {
            console.log(error)
            await manager.releaseTransaction();
            throw error;
        }
    }

    async getSoakingDataById(plantReq: SoakingDetailsRequest): Promise<SoakingDetailViewResponseModel> {
        const soakingDetails = await this.logRepository.findOne({ where: { productionLogId: plantReq.productionLogId, plantId: plantReq.plantId } });
        console.log('soakingDetails' + soakingDetails);
        const soNo = await this.saleOrderService.getSaleOrderItemsForSo({ saleOrderId: soakingDetails.saleOrderId });
        const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: soakingDetails.saleOrderItemId });

        const data = new SoakingDto(soakingDetails.productionLogId, soakingDetails.jobNumber, soakingDetails.lotNumber, soakingDetails.workStationType, soakingDetails.saleOrderId, soNo.data.saleOrder, soItemInfo.data.variantCode, soakingDetails.soakingStyle, soakingDetails.soakingTime, soakingDetails.inputQuantity, soakingDetails.jobStatus, soakingDetails.assignFreezing, soakingDetails.shift, soakingDetails.assignedTime, soakingDetails.plantId, soakingDetails.createdUser, 0, "", soakingDetails.saleOrderItemId, Number(soakingDetails.inputGrade), Number(soakingDetails.actualGrade), soakingDetails.operationType, soakingDetails.outputBoxes, soakingDetails.subLotNumber, soakingDetails.subPlantId);
        if (soakingDetails) {
            return new SoakingDetailViewResponseModel(true, 1001, 'Soaking Details retrived successfully. ', data);
        }
        else {
            return new SoakingDetailViewResponseModel(false, 1010, 'no data found. ');
        }
    }

    async getsoakingStatusWiseDetails(plantReq: UnitRequest): Promise<SoakingStatusWiseResponseModel> {
        try {
            const workstationsList: any = await this.workstations.getAllWorkStationsForCategory({ workstationCategory: 5, unitId: plantReq.unitId });
            // const data : SoakingStatusWiseResponseDto[] = [];
            const qty = new SoakingStatusWiseResponseDto();
            console.log(workstationsList, 'workstation list')
            if (workstationsList.data.length > 0) {
                const inprogressQuantity = [];
                const completedQuantity = [];
                for (const res of workstationsList.data) {
                    const soakingDetails = await this.logRepository.getSoakingStatusWiseDetails(res.workstation, plantReq.unitId);
                    if (soakingDetails.length > 0) {
                        console.log(soakingDetails);
                        for (const res of soakingDetails) {
                            if (res.jobStatus === JobCompletedEnum.NO) {
                                const inprogressQty = Number(res.inputQuantity);
                                inprogressQuantity.push(inprogressQty);
                                if (soakingDetails.length === 1) {
                                    const completedQty = 0;
                                    completedQuantity.push(completedQty);
                                }
                            }
                            else if (res.jobStatus === JobCompletedEnum.YES) {
                                const completedQty = Number(res.inputQuantity);
                                completedQuantity.push(completedQty);
                                if (soakingDetails.length === 1) {
                                    const inprogressQty = 0;
                                    inprogressQuantity.push(inprogressQty);
                                }
                            }
                        }
                    }
                    else {
                        const inprogressQty = 0;
                        inprogressQuantity.push(inprogressQty);
                        const completedQty = 0;
                        completedQuantity.push(completedQty);
                    }
                    qty.inprogressQty = inprogressQuantity;
                    qty.completedQty = completedQuantity;
                    // data.push(qty);
                }
                return new SoakingStatusWiseResponseModel(true, 1111, 'Workstations Found Successfully', qty);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            console.log(error)
            return error
        }
    }
    async getInProgressWorkstations(plantReq: UnitRequest): Promise<workstationsStatusResponseModel> {
        // const data:WorkStationsResponseDto[] = [];
        // const inprogressWorkStations = await this.logRepository.createQueryBuilder("ProductionLog")
        // .leftJoinAndSelect('ProductionLog.workstation', 'workstation')
        // .where("ProductionLog.operationType = '"+OperationTypeEnum.SOAKING + "'")
        // .andWhere("ProductionLog.plantId = "+plantReq.unitId)
        // // .andWhere("date(ProductionLog.assignedTime)=date(now())")
        // .orderBy("ProductionLog.jobStatus", "DESC").getMany();

        // const inprogressWorkStations = await this.logRepository.find({relations:["workstation"],where:{operationType:OperationTypeEnum.SOAKING, plantId:plantReq.unitId, assignedTime:Date.now()}, order:{jobStatus:'DESC'}});
        // console.log(inprogressWorkStations);
        // for (const res of inprogressWorkStations) {
        //     const saleOrderNo =  await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: res.saleOrderId });
        //     const response = new WorkStationsResponseDto(res.jobNumber,saleOrderNo.saleOrderNumber,res.workstation.workstation,res.lotNumber,res.soakingTime,res.soakingStyle,res.inputQuantity,res.assignedTime,res.reportedTime,res.jobStatus,saleOrderNo.poNumber);
        //     data.push(response);
        // }


        const manager = getManager()
        const query = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + plantReq.unitId;
        const result = await manager.query(query);
        var dataQuery = `SELECT pl.job_number as jobNumber,sid.po_number as poNumber, w.workstation as workstation,pl.lot_number as lotNumber,pl.soaking_time as soakingTime , pl.soaking_style as soakingStyle,pl.input_quantity as inputQuantity,pl.assigned_time as assignedTime , pl.reported_time as reportedTime ,pl.job_status as jobStatus FROM ` + appSettings.production_db + `.production_log pl LEFT JOIN ` + appSettings.production_db + `.workstations w ON w.workstation_id = pl.workstation LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = pl.sale_order_id WHERE pl.operation = "${OperationTypeEnum.SOAKING}" `
        if (result[0].plant_type == UnitTypeEnum.SUB_PLANT) {
            dataQuery += "AND pl.sub_plant_id=" + plantReq.unitId;
        } else {
            dataQuery += "AND pl.plant_id=" + plantReq.unitId + ' and pl.sub_plant_id = 0';
        }
        dataQuery = dataQuery + ` ORDER BY pl.job_status DESC `
        const response = await manager.query(dataQuery);
        if (response.length > 0) {
            return new workstationsStatusResponseModel(true, 1001, 'Workstations data retrived Successfully ', response);
        }
        else {
            return new workstationsStatusResponseModel(false, 1010, 'no data found. ');
        }
    }

    // async jobCompletedStatus(soakingInfo: SoakingDto): Promise<assignSoakingForFreezingResponse> {
    //     // const manager = new GenericTransactionManager();
    //     const updateStatus = await this.logService.update(
    //         { productionLogId: Raw((alias) => `production_log_id = '${soakingInfo.productionLogId}'`) },
    //         { jobStatus: JobCompletedEnum.YES }
    //     );
    //     if (updateStatus) {
    //         const prodLog =  new ProductionLog();
    //         prodLog.jobNumber = 'job001';
    //         prodLog.lotNumber = soakingInfo.lotNumber;
    //         prodLog.saleOrderId = soakingInfo.saleOrderId;
    //         prodLog.inputQuantity = soakingInfo.quantity;
    //         prodLog.assignFreezing = soakingInfo.assignFreezing;
    //         prodLog.jobStatus = soakingInfo.jobStatus;
    //         prodLog.shift = soakingInfo.shift;
    //         prodLog.assignedTime = soakingInfo.assignedTime;
    //         prodLog.plantId = soakingInfo.plantId;
    //         prodLog.createdUser = soakingInfo.createdUser;
    //         prodLog.workstation = new WorkStations();
    //         prodLog.workstation.workstationId = soakingInfo.workstation;
    //         prodLog.saleOrderItemId = soakingInfo.saleOrderItemId;
    //         const saveProdLog = await this.logService.save(prodLog);

    //         return new assignSoakingForFreezingResponse(true, 1111, 'Updated to completed');

    //     } else {
    //         throw new ErrorResponse(9999, 'Failed to update');
    //     }
    // }


    // async getAllSoakingInfo(plantId: number) {
    //     const soakingInfo = await this.inventoryRepository.getAllSoakingInfo(plantId);
    // }

    // async getAllSoakingInventoryInfo(plantId: number) {
    //     try {
    //         const soakingInfo: ProductionLog[] = await this.inventoryRepository.getAllInventoryInfo(plantId, OperationTypeEnum.SOAKING);
    //         if (soakingInfo && soakingInfo.length) {
    //             const soakingDetails: SoakingDto[] = [];
    //             for (const soakingData of soakingInfo) {
    //                 const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({saleOrderItemId:soakingData.saleOrderItemId})
    //                 soakingDetails.push(new SoakingDto(soakingData.productionLogId, soakingData.jobNumber, soakingData.lotNumber, soakingData.workStationType, soakingData.saleOrderId, soItemInfo.data.saleOrderNo, soItemInfo.data.variantCode, soItemInfo.data.soakingStyle, soItemInfo.data.soakingTime, soakingData.inputQuantity, soakingData.jobStatus, soakingData.assignFreezing, soakingData.shift, soakingData.assignedTime, soakingData.plantId, soakingData.createdUser, soakingData.workstation.workstationId, soakingData.saleOrderItemId))
    //             }
    //             console.log(soakingDetails);
    //             return new AllSoakingResponseModel(true, 1111, 'Soaking Information Retrieved Successfully', soakingDetails)
    //         } else {
    //               throw new ErrorResponse(99999, 'No Data Found');
    //         }
    //     } catch (error) {
    //         return error
    //     }

    // }


    async createSoakingAssignmentForV2(inputReq: AssignSoakingDto): Promise<assignSoakingForFreezingResponse> {
        console.log(inputReq);
        inputReq.ipBoxes = 0
        inputReq.wipQuantity = inputReq.physicalQuantity
        inputReq.operation = OperationTypeEnum.SOAKING


        const manager = new GenericTransactionManager();
        try {
            let columnName = 'plantId';

            const productionInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: inputReq.lotNumber, subLotNumber: inputReq.subLotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: OperationTypeEnum.SOAKING, plantId: inputReq.plantId } });
            console.log(productionInventoryData,'--pro inv data--')
            let prodInvResponse;
            await manager.startTransaction();
            if (productionInventoryData) {
                prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryQuantity(inputReq, columnName);
            } else {
                // Getting variant information for so item id
                const variantInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: inputReq.saleOrderItemId });
                if (!variantInfo.status) {
                    throw new ErrorResponse(10000, 'Variant information not found');
                }
                const nextOperation = await this.variantOperationService.getNextOperationForVariantId(new VariantNextOpModel(OperationTypeEnum.SOAKING, variantInfo.data.variantId, inputReq.plantId));
                const prodInv = new ProductionInventory();
                prodInv.lotNumber = inputReq.lotNumber;
                prodInv.createdUser = inputReq.createdUser;
                prodInv.subLotNumber = inputReq.subLotNumber;
                prodInv.saleOrderId = inputReq.saleOrderId;
                prodInv.saleOrderItemId = inputReq.saleOrderItemId;
                prodInv.operation = OperationTypeEnum.SOAKING;
                prodInv.nextOperation = nextOperation;
                prodInv.wipQuantity = inputReq.physicalQuantity;
                prodInv.inputGrade = String(inputReq.inputGrade);
                prodInv.boxes = inputReq.boxes;
                prodInv.plantId = inputReq.plantId;
                if (inputReq.subPlantId) {
                    prodInv.subPlantId = inputReq.subPlantId;
                }
                prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInv);
            }
            console.log('prodInvResponse' + prodInvResponse.productionInventoryId);
            if (prodInvResponse) {
                const productionLogObj = new ProductionLog();
                productionLogObj.lotNumber = inputReq.lotNumber;
                productionLogObj.subLotNumber = inputReq.subLotNumber;
                productionLogObj.saleOrderId = inputReq.saleOrderId;
                productionLogObj.saleOrderItemId = inputReq.saleOrderItemId;
                productionLogObj.operationType = OperationTypeEnum.SOAKING;
                // job number generation 
                let today = new Date();
                let CurrentYear = today.getFullYear();
                let CurrentMonth = today.getMonth();
                let fromDate = 0;
                let toDate = 0;
                let totalRecords = await (await this.logRepository.find({ where: { operationType: OperationTypeEnum.SOAKING } })).length;
                if (CurrentMonth < 4) {
                    fromDate = (CurrentYear - 1);
                    toDate = (CurrentYear );
                } else {
                    fromDate = (CurrentYear );
                    toDate = (CurrentYear + 1);
                }

                totalRecords = totalRecords + 1;

                var refNo = totalRecords + "";
                while (refNo.length < 4) refNo = "0" + refNo;

                const soakingJobNo = "Soaking/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;

                productionLogObj.jobNumber = soakingJobNo;//need to write auto generate logic
                productionLogObj.plantId = inputReq.plantId;
                if (inputReq.subPlantId) {
                    productionLogObj.subPlantId = inputReq.subPlantId;
                }
                productionLogObj.workStationType = inputReq.workStationType;
                // productionLogObj.workstation = new WorkStations();
                productionLogObj.workStation = inputReq.workstation;
                productionLogObj.jobStatus = JobCompletedEnum.NO;
                productionLogObj.inputGrade = String(inputReq.inputGrade);
                productionLogObj.inputQuantity = inputReq.physicalQuantity;
                productionLogObj.plannedGrade = inputReq.boxes;
                productionLogObj.soakingStyle = inputReq.soakingStyle;
                productionLogObj.soakingTime = inputReq.soakingTime;
                productionLogObj.assignedTime = inputReq.assignedTime;
                productionLogObj.assignedUser = inputReq.createdUser;//need to get assigned user
                productionLogObj.shift = inputReq.shift;
                productionLogObj.createdUser = inputReq.createdUser;
                productionLogObj.prodInvId =  productionInventoryData ? productionInventoryData.productionInventoryId : prodInvResponse.productionInventoryId;
                // console.log(productionLogObj,'--productionLogObj--')
                const saveProdLog = await manager.getCustomRepository(ProductionLogRepository).save(productionLogObj);
                // console.log(saveProdLog,'--saveProdLog--')
                const updatePrevOPQty = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryIssuedQuantity(inputReq.lotNumber, inputReq.subLotNumber, inputReq.saleOrderId, inputReq.saleOrderItemId, inputReq.productionInventoryId, inputReq.plantId, inputReq.physicalQuantity);
                // console.log(updatePrevOPQty,'--updatePrevOPQty--')
                if (saveProdLog && updatePrevOPQty) {
                    const req = new ReportSoakingRequest(saveProdLog.productionLogId,inputReq.inputGrade,inputReq.workstation,inputReq.lotNumber,inputReq.physicalQuantity,inputReq.saleOrderItemId,inputReq.plantId,inputReq.physicalQuantity)
                    const updatedReportedQty = await this.reportSoakingAssignmentForV2(req,manager)
                    console.log(updatedReportedQty,'----------')
                    if(updatedReportedQty.status){
                        await manager.completeTransaction();
                        return new assignSoakingForFreezingResponse(true, 5555, 'Work station allocated and material assigned to Soaking', true)
                    }else{
                        await manager.releaseTransaction();
                        return new assignSoakingForFreezingResponse(false, 9999, 'some thing went wrong', false)
                    }
                } else {
                    await manager.releaseTransaction();
                    return new assignSoakingForFreezingResponse(false, 9999, 'some thing went wrong', false)
                }
            }

        } catch (error) {
            console.log(error)
            await manager.releaseTransaction();
            throw error;
        }
    }

    async reportSoakingAssignmentForV2(inputReq: ReportSoakingRequest,manager?:GenericTransactionManager): Promise<assignSoakingForFreezingResponse> {
        // const manager = new GenericTransactionManager();
        // try {
            // await manager.startTransaction();
            const opSequence = await this.variantOperationService.getOperationSequence(new OperationSequenceRequest(inputReq.plantId, OperationTypeEnum.SOAKING, inputReq.saleOrderItemId));
            let nextOperation = undefined;
            if (opSequence.status) {
                nextOperation = opSequence.data.nextOperation;
            }
            else {
                await manager.releaseTransaction();
                throw new ErrorResponse(99998, 'Next operation not found.');
            }
            console.log(opSequence.data.nextOperation);
            const prodLogUpdateOutPutGrade = await this.logService.updateOutputGradeAndOperationStatus(inputReq.productionLogId, inputReq.workstation, inputReq.lotNumber, inputReq.outputGrade, inputReq.outputQuantity, nextOperation,inputReq.inputQuantity,manager);
            console.log('prodLogUpdateOutPutGrade' + prodLogUpdateOutPutGrade);

            if (prodLogUpdateOutPutGrade) {
                // await manager.completeTransaction()
                return new assignSoakingForFreezingResponse(true, 1001, 'Soaking Reported successfully. ');
            }
            else {
                await manager.releaseTransaction()
                return new assignSoakingForFreezingResponse(false, 1001, 'Something went wrong. ');
            }
        // } catch (error) {
        //     await manager.releaseTransaction();
        //     throw error;
        // }
    }



}
